export const contactsDict = {
  en: {
    whatsApp: 'https://api.whatsapp.com/send?phone=41784901358&text=Hello!',
    telegram: 'https://t.me/Dmitry_Utiev',
    phone: '+436641260472',
  },
  de: {
    whatsApp: 'https://api.whatsapp.com/send?phone=436703082175&text=Hallo!',
    telegram: 'https://t.me/Dmitry_Utiev',
    phone: '+436641260472',
  },
  ru: {
    whatsApp:
      'https://api.whatsapp.com/send?phone=436505404979&text=Здравствуйте!',
    telegram: 'https://t.me/zlata_erlach',
    phone: '+436505404979',
  },
  tr: {
    whatsApp: 'https://api.whatsapp.com/send?phone=436505404979&text=Merhaba!',
    telegram: 'https://t.me/Dmitry_Utiev',
    phone: '+436505404979',
  },
  es: {
    whatsApp: 'https://api.whatsapp.com/send?phone=436505404979&text=Hola!',
    telegram: 'https://t.me/Dmitry_Utiev',
    phone: '+436505404979',
  },
};

export const c2aLabelsDict = {
  en: 'Practical Guide',
  de: 'Praktischer Leitfaden',
  ru: 'Практическое руководство',
  tr: 'Pratik Rehber',
  es: 'Guía práctica',
};

export const c2aActionMessageDict = {
  en: 'Trusted by 500+ investors',
  de: 'Vertraut von über 500 Investoren',
  ru: 'Нам доверяют более 500 инвесторов',
  tr: "500'den fazla yatırımcının güvendiği",
  es: 'Con la confianza de más de 500 inversores',
};

export * from './PricePage';
